module.exports = __webpack_public_path__ + "img/tp3.438b8425.png";